export default [{
  name: '我的活动',
  path: '/usercenter/myactivity',
  icon: 'baoming',
  active: 'myregistration',
  authority: 'admin studio'
}, {
  name: '消息中心',
  path: '/usercenter/message',
  icon: 'xiaoxi',
  authority: 'admin studio'
}, {
  name: '基本信息',
  path: '/usercenter/basicinfo',
  icon: 'xinxi',
  authority: 'admin studio'
}]



// WEBPACK FOOTER //
// ./src/config/usermenu.js